import store from '@/store'
/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export default function checkAuthorities(value) {
    if (value && value instanceof Array && value.length > 0) {
      const roles = store.getters && store.getters.roles
  
      // 判定是否是超级管理员
      if (roles.indexOf('admin:*') > -1) {
        return true
      }
      // 判定角色权限
      const userinfo = store.getters && store.getters.userinfo
      const userinfoRoles = value
    //   console.log("userinfo")
    //   console.log(userinfo)
    //   console.log("userinfoRoles")
    //   console.log(userinfoRoles)

      const hasPermission = userinfo.adminInfoVo.authorities.some(userinfo => {
        return userinfoRoles.includes(userinfo)
      })
      return hasPermission
    } else {
      console.error(`need roles! Like v-userinfo="['admin','editor']"`)
      return false
    }
  }
  